import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import {
  communes,
  provinces,
  regions,
} from 'pages/BusinessProfile/Profile/components/Client/components/constants';
import React from 'react';

interface AddressForm {
  region: string;
  province: string;
  commune: string;
  address: string;
}

interface AddressEditorProps {
  addressForm: AddressForm;
  onAddressChange: (field: keyof AddressForm, value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const AddressEditor: React.FC<AddressEditorProps> = ({
  addressForm,
  onAddressChange,
  onSave,
  onCancel,
  loading = false,
}) => {
  const handleChange =
    (field: keyof AddressForm) =>
    (
      event:
        | React.ChangeEvent<{ value: unknown }>
        | { target: { value: string } },
    ) => {
      const value =
        typeof event.target.value === 'string'
          ? event.target.value
          : String(event.target.value);
      onAddressChange(field, value);
    };

  const handleSave = (event: React.MouseEvent) => {
    event.stopPropagation();
    onSave();
  };

  const handleCancel = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCancel();
  };

  return (
    <Box sx={{ mt: 1 }} onClick={(e) => e.stopPropagation()}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Región</InputLabel>
            <Select
              value={addressForm.region || ''}
              onChange={handleChange('region')}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              label="Región"
            >
              {regions.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Provincia</InputLabel>
            <Select
              value={addressForm.province || ''}
              onChange={handleChange('province')}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              label="Provincia"
            >
              {provinces.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Comuna</InputLabel>
            <Select
              value={addressForm.commune || ''}
              onChange={handleChange('commune')}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              label="Comuna"
            >
              {communes.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            label="Dirección"
            value={addressForm.address}
            onChange={handleChange('address')}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            fullWidth
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <CustomButton
          size="small"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          disabled={loading}
        >
          Guardar
        </CustomButton>
        <CustomButton
          size="small"
          color="secondary"
          startIcon={<CloseIcon />}
          onClick={handleCancel}
        >
          Cancelar
        </CustomButton>
      </Box>
    </Box>
  );
};

export default AddressEditor;
